export default function getDateYmdTm(str) {
    if (str) {
        return str.substr(0, 19);
    }
}


// WEBPACK FOOTER //
// ./src/filters/getDateYmdTm.js